import { GroupSetting } from '@griply/types';
import { createContext, useContext } from 'react';
import { ID } from 'shared/types/id';
import { Task } from 'shared/types/task';

export type DayPartRenderData = {
  groupSettings: GroupSetting;
  tasksMap: Record<ID, Task>;
  tasks: Task[];
  today: Date;
  denseFormat?: boolean;
  defaultNewTaskDate?: Date;
};

export const DayPartRenderDataContext = createContext<DayPartRenderData | null>(
  null,
);

export const useDayPartRenderData = (): DayPartRenderData => {
  const data = useContext(DayPartRenderDataContext);
  if (!data) {
    throw new Error(
      'useDayPartRenderData must be used within a DayPartGroupingTasksList',
    );
  }
  return data;
};
